import TextFieldArea from 'components/TextFieldArea';
import { func, object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';

import ContentColumns from '../../components/ContentColumns';

const View5 = (_, { fmString, formValues, onChange }) => {
  const onChangeText = name => event => {
    const eventValue = path(['currentTarget', 'value'], event);
    onChange({ [name]: eventValue });
  };
  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fmString(`onlineRehabilitation.rehab6.5.header`)}</h2>
            <br />
            <div>
              <h3>{fmString('onlineRehabilitation.rehab6.5.questionToNeurologist')}</h3>

              <TextFieldArea
                editing
                input={{
                  value: path(['rehab6', 'questionToNeurologist'], formValues) || '',
                  onChange: onChangeText('questionToNeurologist'),
                  name: 'questionToNeurologist',
                }}
                placeholder={fmString('onlineRehabilitation.rehab6.5.questionToNeurologistPlaceholder')}
                rows={4}
                style={{ width: '100%' }}
              />
            </div>
          </div>
        }
      />
    </React.Fragment>
  );
};

View5.contextTypes = {
  fmString: func,
  formValues: object,
  onChange: func,
};
export default View5;
